import React from 'react';
import './SingleRate.scss';
import RateStar from "../../../pages/Survey/RateStar";

const SingleRate = ({
                        themeColor,
                        status,
                        rate,
                        hasSpecificRate,
                        selectedRate,
                        selectedColor = null,
                        unselectedBorderColor = null,
                    }) => {
    const isSelected = selectedRate === rate;
    const activeSelectedColor = selectedColor || themeColor;
    const inactiveBorderColor = unselectedBorderColor || themeColor;

    return (
        <div
            className="SingleRate"
            style={
                isSelected && !hasSpecificRate
                    ? { backgroundColor: activeSelectedColor, color: '#FFFFFF', borderColor: activeSelectedColor, textShadow: '0px 0px 3px rgba(0,0,0,0.31)' }
                    : { borderColor: inactiveBorderColor }
            }
        >
            <div className="singleRateNumber">
                {hasSpecificRate ? (
                    <RateStar
                        stroke={themeColor}
                        fill={selectedRate >= rate ? themeColor : 'none'}
                    />
                ) : (
                    <span>{rate}</span>
                )}
            </div>
        </div>
    );
};

export default SingleRate;
